<template functional>
   <img :src="require(`@assets/images/svg-icon/${props.icon}.svg`)" class="img-fluid" :alt="props.icon">
</template>

<script>
export default{
  name: 'SvgIcon',
}
</script>